import { Link } from "react-router-dom";
import { ArrowLeft, ShoppingBag, MessageCircle } from "lucide-react";
import Chat from "@/pages/Chat";

/**
 * Customer-facing wrapper around the shared <Chat/> component.
 * The chat itself is the same room the shop's owner and every employee
 * are in — this page just gives shoppers the familiar shop header + a
 * back link and a short "how it works" tagline.
 *
 * Access control, polling and message rendering live entirely in Chat.jsx
 * so both customer and staff views stay in sync automatically.
 */
export default function ShopChat() {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <header className="bg-white border-b border-slate-200 px-4 py-3 flex items-center justify-between">
        <Link
          to="/shop"
          className="inline-flex items-center gap-1.5 bg-[var(--shop-primary,#0055FF)] text-white hover:bg-[var(--shop-primary,#0040CC)] font-semibold text-sm px-3 py-1.5 rounded-md shadow-sm transition-transform hover:-translate-x-0.5"
          data-testid="shop-chat-back-to-shop"
        >
          <ArrowLeft className="w-4 h-4 stroke-[3]" />
          Shop
        </Link>
        <div className="flex items-center gap-2">
          <ShoppingBag className="w-5 h-5 text-[var(--shop-primary,#0055FF)]" />
          <span className="font-heading font-bold">Community chat</span>
        </div>
        <span className="w-16" />
      </header>

      <div className="bg-emerald-50 border-b border-emerald-100 px-4 py-2 text-[11px] text-emerald-800 flex items-center gap-1.5">
        <MessageCircle className="w-3.5 h-3.5" />
        This is the shared chat for the shop — the owner, all staff and every
        customer are here. Photos, videos and voice notes auto-delete after 48
        hours; text stays.
      </div>

      <div className="flex-1 min-h-0">
        <Chat compact />
      </div>
    </div>
  );
}
